// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2h6YH","title":"Images45_title__1Lbmy","images":"Images45_images__1SRuq"};